var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCustomerSegmentation = function SvgCustomerSegmentation(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.182 14.711A1.18 1.18 0 0 0 4 15.89v10.94c0 .648.53 1.176 1.181 1.176h18.194a1.18 1.18 0 0 0 1.182-1.177V15.89c0-.65-.53-1.179-1.182-1.179H5.182Zm18.195 14.623H5.182a2.514 2.514 0 0 1-2.515-2.507V15.89a2.513 2.513 0 0 1 2.515-2.507h18.194a2.514 2.514 0 0 1 2.516 2.507v10.938a2.514 2.514 0 0 1-2.516 2.506h.001Z",
    fill: "#5981E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.263 27.129c-.45 0-.902-.172-1.244-.514l-9.78-9.743a1.753 1.753 0 0 1 0-2.48l.943.94a.424.424 0 0 0 0 .6l9.779 9.744a.43.43 0 0 0 .604 0l9.78-9.744a.424.424 0 0 0 0-.601l.943-.94a1.752 1.752 0 0 1 0 2.48l-9.78 9.745a1.755 1.755 0 0 1-1.245.513",
    fill: "#5981E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.074 28.453-.76-1.091 6.822-4.723.76 1.091-6.822 4.723Zm20.772 0-6.823-4.723.76-1.091 6.823 4.723-.76 1.09Zm.282-19.46H14.102a.957.957 0 0 1-.953-.953V6.455c0-.524.43-.953.953-.953h11.026c.523 0 .953.43.953.953V8.04c0 .524-.43.953-.953.953Zm.608 2.447H13.723a.5.5 0 0 1-.5-.497.5.5 0 0 1 .5-.499h12.013a.5.5 0 1 1 0 .997",
    fill: "#5981E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.598 27.375H24.89v-1.328h1.707c.773 0 1.402-.628 1.402-1.398V5.392c0-.77-.629-1.397-1.402-1.397H12.842a1.4 1.4 0 0 0-1.402 1.397v8.885h-1.334V5.392a2.734 2.734 0 0 1 2.736-2.726h13.756a2.734 2.734 0 0 1 2.736 2.726v19.257a2.734 2.734 0 0 1-2.737 2.726",
    fill: "#5981E3"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomerSegmentation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "c37707d6634332675a875e2358fd8bbe.svg";